import React from "react";
import { Link } from "react-router-dom";
import { ShoppingCart } from "phosphor-react";
import { useState } from "react";
import { PRODUCT } from "./products";

import Product from "./Product";
import Homepage from "./Homepage";


const NavBar = (props) => {


 const [item,setItems]=useState(PRODUCT);

 
 props.data(item)
 



const filterItems = (item)=>{
  const updateItems=PRODUCT.filter((items)=>{
    return items.category === item;
  })
  setItems(updateItems)
  
}
const filterItems1 = (item1)=>{
  const updateItems=PRODUCT.filter((items1)=>{
    return items1.colour === item1;
  })
  setItems(updateItems)
  
}


  return (
    


      <div className="">
        <div className=" w-screen h-[3rem] py-2 bg-slate-300    ">
          <ul className="w-[48rem]  flex  gap-[7rem]  ">
            <li className="relative text-lg">ASTHETIC</li>
            <Link to="/" className="text-lg">
              HOME
            </Link>
            <li className="group relative dropdown  px-4 text-purple-500 hover:text-purple-700 cursor-pointer font- text-base uppercase tracking-wide">
              <a>Category</a>
              <div className="group-hover:block text-lg dropdown-menu absolute hidden h-auto">
                <ul className="top-0 w-48 bg-white shadow px-6 py-8 block text-blue-500  text-base  hover:text-purple-700 cursor-pointer">
                  <li className="py-1">
                    <a onClick={() => filterItems("dress")}>Dress</a>
                  </li>
                  <li className="py-1">
                    <a onClick={() => filterItems("purse")}>Purse</a>
                  </li>
                  <li className="py-1">
                    <a onClick={() => filterItems("top")}>Tops</a>
                  </li>
                 
                </ul>
              </div>
            </li>
            <li className="group relative dropdown  px-4 text-purple-500 hover:text-purple-700 cursor-pointer font- text-base uppercase tracking-wide">
              <a>Colour</a>
              <div className="group-hover:block dropdown-menu absolute hidden h-auto">
                <ul className="top-0 w-48 bg-white shadow px-6 py-8 block text-blue-500  text-base  hover:text-purple-700 cursor-pointer">
                  <li className="py-1">
                    <a onClick={() => filterItems1("Black")}>Black</a>
                  </li>
                  <li className="py-1">
                    <a onClick={() => filterItems1("Green")}>Green</a>
                  </li>
                  <li className="py-1">
                    <a onClick={() => filterItems1("Blue")}>Blue</a>
                  </li>
                  <li className="py-1">
                    <a onClick={() => filterItems1("Red")}>Red</a>
                  </li>
                  <li className="py-1">
                    <a onClick={() => filterItems1("White")}>White</a>
                  </li>
                </ul>
              </div>
            </li>
            <button className="text-white text-center text-lg h-8   mt-[-4] " onClick={()=>setItems(PRODUCT)}>RESET</button>

            <div className="flex justify-center">
              <div className="mb-3 xl:w-96">
                <div className="input-group relative flex flex-wrap items-stretch  mb-4 rounded ">
                  <input
                    type="search"
                    className="form-control relative flex-auto  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    placeholder="Search"
                    aria-label="Search"
                    aria-describedby="button-addon2"
                  ></input>
                </div>
              </div>
            </div>

            <Link to="/cart" className="ml-[-6rem]">
              <ShoppingCart size={32} />
            </Link>
          </ul>
        </div>
      </div>
 
  );
};

export default NavBar;
